import { Scale } from "lucide-react";
import { Card } from "@/components/ui/card";

const TO_KG = { kg: 1, mt: 1000, ton: 1000 };
const SOLD = ["Sold", "Dispatched"];
const fmtKg = (n) => `${Number(n.toFixed(2)).toLocaleString("en-IN")} kg`;

export function soldWeights(items) {
  const byType = {};
  let total = 0, skipped = 0;
  items.filter((r) => SOLD.includes(r.status)).forEach((r) => {
    const w = parseFloat(String(r.actual_weight ?? "").replace(/,/g, ""));
    const f = TO_KG[String(r.weight_unit || "MT").toLowerCase()];
    if (!w || !f) { skipped += 1; return; }
    const kg = w * f;
    const t = r.category || "Other";
    byType[t] = (byType[t] || 0) + kg;
    total += kg;
  });
  return { total, skipped, rows: Object.entries(byType).sort((a, b) => b[1] - a[1]) };
}

export function MaterialWeightTile({ items }) {
  const { total, skipped, rows } = soldWeights(items);
  return (
    <Card className="p-5 border-emerald-200 bg-emerald-50/50 dark:bg-emerald-950/20" data-testid="material-sold-weight-tile">
      <div className="flex items-center gap-2 text-sm font-medium text-muted-foreground"><Scale className="h-4 w-4 text-emerald-600" />Total Weight Sold (all records)</div>
      <div className="font-display text-3xl font-bold mt-1" data-testid="material-sold-weight-total">{fmtKg(total)}</div>
      {rows.length > 0 ? (
        <div className="mt-3 flex flex-wrap gap-2" data-testid="material-sold-weight-breakdown">
          {rows.map(([t, kg]) => (
            <span key={t} className="rounded-full border border-emerald-200 bg-background px-3 py-1 text-sm" data-testid={`material-sold-weight-${t.replace(/\s+/g, "-").toLowerCase()}`}>
              <span className="text-muted-foreground">{t}:</span> <b>{fmtKg(kg)}</b>
            </span>
          ))}
        </div>
      ) : <p className="mt-2 text-xs text-muted-foreground">No sold records with a weight yet.</p>}
      {skipped > 0 && <p className="mt-2 text-xs text-amber-700" data-testid="material-sold-weight-skipped">{skipped} sold record{skipped > 1 ? "s" : ""} not counted: no weight entered or unit is Nos.</p>}
    </Card>
  );
}
